import { Input } from '@/components/atoms/Form/Input';
import { Control, Controller, Form, useForm } from 'react-hook-form';
import React from 'react';
import { computeText } from '@/locales/utils';
import { useIntl } from 'react-intl';

interface SplioConfigCreateFormProps {
    control: Control<{ splioApiKey: string }>;
    canChangeProvider: boolean;
}

const SplioConfigCreateForm = ({ control, canChangeProvider }: SplioConfigCreateFormProps) => {
    const intl = useIntl();
    return (
        <Form control={control}>
            <Controller
                control={control}
                name="splioApiKey"
                rules={{
                    required: computeText(intl, 'field.required'),
                    validate: (value) =>
                        value && (canChangeProvider || computeText(intl, 'splio.error.changeProvider')),
                }}
                render={({ field, fieldState }) => (
                    <Input
                        {...field}
                        labelId="splio.apiKey"
                        placeholder="splio.apiKey.placeholder"
                        error={fieldState.error?.message}
                    />
                )}
            />
        </Form>
    );
};

export default SplioConfigCreateForm;
